import { useSelector } from 'react-redux';
import { getCustomStyles } from 'redux/selectors/global';
import { useEffect } from 'react';
import { trackCSSInjection } from 'utilities/analytics/sdk';

export function useCSSInjectionTracking() {
  const customStyles = useSelector(getCustomStyles);

  useEffect(() => {
    trackCSSInjection({ customStyles });
  }, [customStyles]);
}
